import { useCallback, useEffect, useState } from 'react';

import { useHistory, useParams } from 'react-router-dom';

import { useIntl } from 'react-intl';

import {
  useAPIFetchApplicationPublic,
  useAPIFetchApplicationDocumentations,
  useAPIFetchPartnerDetails,
} from '@marketplace/api';

import { Documentation, Overview, PartnerDetails } from './tabs-content';

export default function useApplicationPage() {
  const { push } = useHistory();

  const { formatMessage } = useIntl();

  const { id } = useParams<{ id: string }>();

  const { data, loading } = useAPIFetchApplicationPublic(id);

  const { data: appDocumentationsData } =
    useAPIFetchApplicationDocumentations(id);

  const {
    data: partnerDetailsData,
    loaded: partnerDetailsLoaded,
    loading: partnerDetailsLoading,
  } = useAPIFetchPartnerDetails(id);

  const [activeTab, setActiveTab] = useState(0);

  const handleChangeTab = useCallback((activeTab: number) => {
    setActiveTab(activeTab);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tabsContent = [
    {
      title: formatMessage({ id: 'app_gallety_overview' }),
      content: <Overview data={data} applicationId={id} />,
    },
    {
      title: formatMessage({ id: 'app_gallety_documentation' }),
      content: (
        <Documentation
          licenses={appDocumentationsData.licenses}
          documentations={appDocumentationsData.documentations}
        />
      ),
    },
    {
      title: formatMessage({ id: 'app_gallety_dev_details' }),
      content: (
        <PartnerDetails
          data={partnerDetailsData}
          loaded={partnerDetailsLoaded}
          loading={partnerDetailsLoading}
        />
      ),
    },
  ];

  const handleOnClickBackToApps = useCallback(() => {
    push('/app-gallery');
    // eslint-disable-next-line
  }, []);

  return {
    handleOnClickBackToApps,
    loading,
    data,
    partnerDetailsData,
    handleChangeTab,
    tabsContent,
    activeTab,
  };
}
